import { createTheme } from '@mui/material/styles';

export const MAIN_THEME_COLOR = '#559178';
export const DARK_THEME_COLOR = '#374649';
export const ERROR_THEME_COLOR = '#E04E4E';
export const YELLOW_THEME_COLOR = '#FFFB9B';
export const MAIN_BG_COLOR = '#275E63';
export const WHITE_COLOR = '#fff';
export const DROPDOWN_BOX_SHADOW = '0px 5px 5px -3px rgba(0,0,0,0.2), 0px 8px 10px 1px rgba(0,0,0,0.14), 0px 3px 14px 2px rgba(0,0,0,0.12)';
export const LABEL_FORM_COLOR = 'rgba(55, 70, 73, 0.5)';

export const mainTheme = createTheme({
  palette: {
    primary: {
      main: MAIN_THEME_COLOR,
    },
    secondary: {
      main: WHITE_COLOR,
      light: '#fafafa',
    },
    error: {
      main: ERROR_THEME_COLOR,
    },
  },
  components: {
    MuiSnackbar: {
      styleOverrides: {
        root: {
          bottom: 100,

          '@media (min-width: 600px)': {
            bottom: 100,
          },
        },
      },
      defaultProps: {
        anchorOrigin: {
          horizontal: 'center',
          vertical: 'bottom',
        },
      },
    },
    MuiPickersLayout: {
      styleOverrides: {
        root: {
          '& .MuiButton-root': {
            height: 'auto',
            minWidth: 'auto',
          },
          '& .MuiDateTimePickerToolbar-ampmSelection span': {
            color: 'rgba(0, 0, 0, 0.38)',

            '&.Mui-selected': {
              color: MAIN_THEME_COLOR,
            },
          },
        },
      },
    },
    MuiTimePicker: {
      defaultProps: {
        timezone: 'UTC',
      },
    },
    MuiFormLabel: {
      styleOverrides: {
        root: {
          color: LABEL_FORM_COLOR,
        },
      },
    },
    MuiDateTimePicker: {
      defaultProps: {
        timezone: 'UTC',
      },
    },
    MuiDatePicker: {
      defaultProps: {
        open: false,
        okLabel: 'Ok',
        timezone: 'UTC',
      },
    },
    MuiPickersPopper: {
      styleOverrides: {
        paper: {
          boxShadow: '0px 0px 28px rgba(0, 45, 61, 0.08)',
        },
      },
    },
    MuiAutocomplete: {
      styleOverrides: {
        popper: {
          boxShadow: DROPDOWN_BOX_SHADOW,
        },
      },
    },
    MuiButton: {
      defaultProps: {
        disableRipple: true,
      },
      styleOverrides: {
        root: {
          textTransform: 'unset',
        },
      },
    },
    MuiTextField: {
      defaultProps: {
        variant: 'standard',
      },
    },
    MuiSelect: {
      defaultProps: {
        variant: 'standard',
        autoWidth: true,
      },
      styleOverrides: {
        select: {
          paddingLeft: 10,
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        shrink: {
          transform: 'none',
          fontSize: 14,
          color: 'rgba(55, 70, 73, 0.5)',
          lineHeight: '140%',
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        rounded: {
          borderRadius: 4,
        },
      },
    },
    MuiTabs: {
      styleOverrides: {
        indicator: {
          height: 2,
        },
      },
    },
    MuiPopover: {
      styleOverrides: {
        paper: {
          boxShadow: DROPDOWN_BOX_SHADOW,
        },
      },
    },
    MuiList: {
      styleOverrides: {
        root: {
          padding: 0,
        },
      },
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          fontSize: 14,
          fontWeight: 400,
          color: DARK_THEME_COLOR,
          backgroundColor: WHITE_COLOR,
          padding: '8px 16px',
          lineHeight: '20px',
          boxShadow: DROPDOWN_BOX_SHADOW,
          whiteSpace: 'pre-wrap',
          maxHeight: '70dvh',
          overflow: 'auto',

          '@media screen and (max-width: 767px)': {
            maxHeight: '50dvh',
          },
        },
        arrow: {
          color: WHITE_COLOR,
        },
        popper: {
          boxShadow: 'none',
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          fontSize: 14,
        },
      },
    },
    MuiCardContent: {
      styleOverrides: {
        root: {
          '&:last-child': {
            paddingBottom: 16,
          },
        },
      },
    },
    MuiCardHeader: {
      styleOverrides: {
        title: {
          fontSize: 16,
          fontWeight: 700,
        },
        root: {
          padding: '24px 24px 8px 24px',

          '&+.MuiCardContent-root': {
            paddingTop: 0,
          },
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: MAIN_BG_COLOR,
        },
      },
    },
    MuiDrawer: {
      styleOverrides: {
        paper: {
          backgroundColor: MAIN_BG_COLOR,
          color: WHITE_COLOR,

          '& .MuiIconButton-root ': {
            color: WHITE_COLOR,
          },

          '& .MuiListItemIcon-root ': {
            color: WHITE_COLOR,
          },
        },
      },
    },
  },
  shadows: [
    'none',
    '0px 0px 28px rgba(0, 45, 61, 0.08)',
    '0px 0px 28px rgba(0, 45, 61, 0.08)',
    '0px 0px 28px rgba(0, 45, 61, 0.08)',
    ...Array(21).fill('none'),
  ],
});
